import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {Link} from 'react-router-dom';
import {FormHelperText, Grid} from '@material-ui/core';
import {
    TextField,
    OutlinedInput,
    InputAdornment,
    IconButton,
    InputLabel,
    FormControl,
    Button
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import _isEqual from "lodash/isEqual";

import {login, userLoginFormChange, resetUserLoginForm} from '../../vendors/actions/user';

import MultiRoute from '../multiRoute/multiRoute'
import Typography from "@material-ui/core/Typography";


interface OwnProps {
    userLogin?: any,
    UserLoginForm?: any,
    userLoginFormChange?: any,
    resetUserLoginForm?: any,
    embedded?: boolean,
}

interface MainState {
    user: any,
    form: any,
    loggedIn: boolean,
    showPassword: boolean,
    unhandledError: string,
    errorList: any
}

interface ConnectStateProps {
    User: any,
    UserLoginForm: any
}


interface ConnectDispatchProps {
    userLogin?: (data: any) => void;
    userLoginFormChange?: (data: any) => void;
    resetUserLoginForm?: (data: any) => void;
    errorList?: (data: any) => void;
}


type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;


const loginLawyerRoute = [
    {
        link: '/',
        title: 'Find a Lawyer',
        className: '',
    },
    {
        link: '/login',
        title: 'Log In',
        className: 'active',
    }
];

const ERROR_CODES: {
    [key: string]: string
} = {
    "400_1": "password",
    "400_2": "email",
    "400_3": "email",
    "400_19": "password",
};

class UserLoginForm extends React.Component<HeaderProps, MainState> {
    state = {
        user: {
            first_name: ''
        },
        errorList: {},
        loggedIn: false,
        showPassword: false,
        unhandledError: '',
        form: {
            valid: false,
            email: {
                value: '',
                error: false,
                dirty: false

            },
            password: {
                value: '',
                error: false,
                dirty: false
            }
        }
    };

    componentDidMount(): void {
        const {User} = this.props;

        if (Object.keys(User).length) {
            this.setState({user: User, loggedIn: true});
        }
    }

    componentWillUnmount() {
        this.props.resetUserLoginForm()
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {UserLoginForm, User} = props;
        if (UserLoginForm && (!_isEqual(state.form, UserLoginForm.data))) {
            return {
                form: UserLoginForm.data
            };
        }
        if (Object.keys(User).length && (!_isEqual(state.user, User))) {
            return {
                user: User,
                loggedIn: true
            }
        }
        return null;
    }

    setEmail = (e: any,validate: boolean = false) => {
        const value = e.target.value;
        this.props.userLoginFormChange({value, field: 'email', validate});
    };

    setPassword = (e: any,validate: boolean = false) => {
        const value = e.target.value;
        this.props.userLoginFormChange({value, field: 'password', validate});
    };

    triggerShowPassword = () => {
        const {showPassword} = this.state;
        this.setState({showPassword: !showPassword})
    };

    validate() {
        const {UserLoginForm} = this.props;
        for (const prop in UserLoginForm.data) {
            const value = UserLoginForm.data[prop].value;
            this.props.userLoginFormChange({value, field: prop, validate: true});
        }
    }

    async submit() {
        const {UserLoginForm} = this.props;
        this.validate();
        const email = UserLoginForm.data.email.value;
        const password = UserLoginForm.data.password.value;

        if (email && !UserLoginForm.data.email.error) {
            const res = await this.props.userLogin({email, password});
            if (res?.type && res.type === 'USER_LOGIN_ERROR') {
                const code = res.payload?.data?.error_id;

                if (ERROR_CODES[code]) {
                    this.props.userLoginFormChange({
                        value: UserLoginForm.data[ERROR_CODES[code]]?.value || '',
                        field: ERROR_CODES[code],
                        apiError: code || ''
                    });
                } else {
                    this.setState({unhandledError: 'Something went wrong.'});
                }
            }
        }
    }

    render() {
        const {embedded} = this.props;
        const {form, showPassword, unhandledError} = this.state;
        return (
            <Fragment>

                {!embedded ?
                    <Fragment>
                        <div className={`multi-route-wrapper main-context-left-m `}>
                            <MultiRoute wrapperClassName={'pt-5 pb-5'}
                                        routes={loginLawyerRoute}/>
                            <div className="mb-5">
                                <div className="MuiTypography-root login-title-wrapper">
                                    <Typography className={'primary-title'}>
                                        Welcome Back!
                                    </Typography>
                                    <Typography  className={'mb-2 sec-title'} display="block" gutterBottom>
                                        Log In to continue.
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </Fragment>

                    : null}
                <Grid
                    item
                    xs={12}
                    md={!embedded ? 10 : 12}
                    lg={!embedded ? 9 : 12}
                    className="d-flex align-items-center">
                    <form className={`w-100 ${!embedded ? 'main-context-left-m' : ''} w-100`}>
                        <div className={'text-field-custom-mb'}>
                            <TextField
                                fullWidth
                                error={!!form?.email?.error && form?.email?.dirty}
                                helperText={form?.email?.dirty && form?.email?.error ? form?.email?.error :''}
                                onChange={this.setEmail}
                                onBlur={(e)=> this.setEmail(e, true)}
                                label="Email"
                                id="email"
                                variant="outlined"
                            />
                        </div>
                        <div className={'mb-1'}>
                            <FormControl
                                fullWidth
                                error={!!form?.password?.error && form?.password?.dirty}
                                onBlur={(e)=> this.setPassword(e, true)}
                                variant="outlined">
                                <InputLabel htmlFor="password">
                                    Password
                                </InputLabel>
                                <OutlinedInput
                                    fullWidth
                                    error={!!form?.password?.error && !!form?.password?.dirty}
                                    id="password"
                                    type={showPassword ? 'text' : 'password'}
                                    onChange={this.setPassword}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={this.triggerShowPassword}
                                                onMouseDown={(e) => e.preventDefault()}
                                                edge="end">
                                                {showPassword ? (
                                                    <Visibility/>
                                                ) : (
                                                    <VisibilityOff/>
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    labelWidth={70}
                                />
                                <FormHelperText error={!!form?.password?.error && form?.password?.dirty}>{form?.password?.error}</FormHelperText>
                            </FormControl>
                        </div>
                        <div className={'mb-3 text-right'}>
                            <Link to={'/forgot-password'}>
                                Forgot Password?
                            </Link>
                        </div>
                        <div className={`mt-4 text-right form-action ${!embedded ? 'general-page' : ''}`}>
                            <Button
                                onClick={() => this.submit()}
                                variant="contained"
                                color="primary"
                                className={`mt-4 login-button and-lawyers-button mr-0`}>Log In
                            </Button>
                            <div className={`mt-3 mb-3`}>
                                <FormHelperText className={`text-right`} error={!!unhandledError}>{unhandledError}</FormHelperText>
                            </div>
                        </div>
                    </form>
                </Grid>
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, UserLoginForm} = state;
    return {
        User,
        UserLoginForm
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        userLogin: (data: any) => dispatch(login(data)),
        userLoginFormChange: (data: any) => dispatch(userLoginFormChange(data)),
        resetUserLoginForm: (data: any) => dispatch(resetUserLoginForm(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserLoginForm);
